(function () {
  var realBtn = document.querySelector('button[name="add"]');
  if (!realBtn) return;

  var style = document.createElement('style');
  style.textContent = [
    '.tcl-satc{position:fixed;bottom:0;left:0;right:0;z-index:200;',
    'background:rgb(var(--color-background));',
    'border-top:1px solid rgba(var(--color-foreground),.1);',
    'padding:1.2rem 1.6rem;transform:translateY(110%);',
    'transition:transform .3s ease;box-shadow:0 -4px 12px rgba(0,0,0,.08)}',
    '.tcl-satc.tcl-satc--visible{transform:translateY(0)}',
    '.tcl-satc__inner{max-width:var(--page-width);margin:0 auto;display:flex;align-items:center;gap:1.6rem}',
    '.tcl-satc__info{flex:1;min-width:0}',
    '.tcl-satc__title{font-family:var(--font-heading-family);font-size:1.4rem;',
    'font-weight:var(--font-heading-weight);white-space:nowrap;overflow:hidden;',
    'text-overflow:ellipsis;color:rgb(var(--color-foreground));margin:0;line-height:1.3}',
    '.tcl-satc__variant{font-size:1.2rem;color:rgba(var(--color-foreground),.65);',
    'margin:.2rem 0 0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    '.tcl-satc__price{font-size:1.5rem;font-weight:700;color:rgb(var(--color-foreground));',
    'white-space:nowrap;flex-shrink:0}',
    '.tcl-satc__btn{white-space:nowrap;flex-shrink:0;padding:1rem 2rem;font-size:1.4rem}',
    '@media(max-width:749px){.tcl-satc__inner{gap:1rem}',
    '.tcl-satc__price{display:none}',
    '.tcl-satc__btn{padding:1rem 1.4rem;font-size:1.3rem}}'
  ].join('');
  document.head.appendChild(style);

  // querySelector returns first in document order — the container <div> would come before
  // its heading children, so we query headings first in a separate call, then fall back.
  var titleEl =
    document.querySelector('.product__title h1, .product__title h2, h1.product__title, h2.product__title') ||
    document.querySelector('.product__title');
  var titleText = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
  var btnLabel = (window.variantStrings && window.variantStrings.addToCart) || realBtn.textContent.trim();

  var bar = document.createElement('div');
  bar.id = 'tcl-satc';
  bar.className = 'tcl-satc';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML =
    '<div class="tcl-satc__inner">' +
      '<div class="tcl-satc__info">' +
        '<p class="tcl-satc__title" id="tcl-satc-title"></p>' +
        '<p class="tcl-satc__variant" id="tcl-satc-variant"></p>' +
      '</div>' +
      '<span class="tcl-satc__price" id="tcl-satc-price"></span>' +
      '<button class="tcl-satc__btn button button--primary" id="tcl-satc-btn" type="button"></button>' +
    '</div>';
  bar.querySelector('#tcl-satc-title').textContent = titleText;
  bar.querySelector('#tcl-satc-btn').textContent = btnLabel;
  document.body.appendChild(bar);

  var stickyBtn = document.getElementById('tcl-satc-btn');
  var variantEl = document.getElementById('tcl-satc-variant');
  var priceEl = document.getElementById('tcl-satc-price');

  function updateVisibility() {
    var show = window.scrollY > 500;
    bar.classList.toggle('tcl-satc--visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  window.addEventListener('scroll', updateVisibility, { passive: true });
  updateVisibility();

  stickyBtn.addEventListener('click', function () { realBtn.click(); });

  function syncPrice() {
    var el = document.querySelector('.price__regular .price-item--regular');
    if (el && priceEl) priceEl.textContent = el.textContent.trim();
  }
  syncPrice();

  var priceContainer = document.querySelector('.price__regular');
  if (priceContainer) {
    new MutationObserver(syncPrice).observe(priceContainer, { childList: true, subtree: true, characterData: true });
  }

  function syncVariant() {
    var vals = [];
    document.querySelectorAll('variant-selects fieldset').forEach(function (fs) {
      var checked = fs.querySelector('input:checked');
      if (checked) vals.push(checked.value);
    });
    document.querySelectorAll('variant-selects select').forEach(function (sel) {
      if (sel.selectedIndex >= 0) vals.push(sel.options[sel.selectedIndex].text);
    });
    var t = vals.filter(Boolean).join(' / ');
    if (variantEl && t) variantEl.textContent = t;
  }
  setTimeout(syncVariant, 100);

  document.addEventListener('change', function (e) {
    if (!e.target.closest('variant-selects, variant-radios')) return;
    setTimeout(syncVariant, 50);
  });
})();
